import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { tpcFlexAnswerDraftSchema, tpcFlexAnswerFinalSchema } from './tpcFlexAnswerSchema';
import { tpcFlexRequestDraftSchema, tpcFlexRequestFinalSchema } from './tpcFlexRequestSchema';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.TPCFlexAnswer,
        draft: tpcFlexAnswerDraftSchema,
        final: tpcFlexAnswerFinalSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.TPCFlexRequest,
        draft: tpcFlexRequestDraftSchema,
        final: tpcFlexRequestFinalSchema,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
